/* eslint-disable react-hooks/exhaustive-deps */
import { each, get, isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import Button from '../Button';
import Modal, { ModalHeader } from '../Modal';
import systemAlert from '../../utils/systemAlert';
import { CATEGORY_SEARCH_OPTIONS } from '../../constants/CATEGORY';
import { createAccountingTitleUse, getAccountingTitleList } from '../../apis/finances/accounting-title';
import { getParams } from '../../utils/params';
import { ControlTable } from '../Table';
import Filters from '../Filters';
import useForm from '../../hooks/useForm';
import { viewLoading } from '../../utils/loading';
import { toast } from '../../utils/toast';
import { uniqBy } from 'lodash';
import { dateToViewFormat } from '../../utils/date';
import { transformComma } from '../../utils/validator/comma';

const CategoryMappingModal = ({ open, setOpen, selectedItem, setSelectedItem, useType, submit,
  mode = "modify", selectIdx = null,
  fields: propsFields = []
}) => {
  const [fields] = useState([
    { title: '카테고리명', key: 'name' },
    { title: "계정체계", key: "class" },
    { title: "코드", key: "code" },
    { title: "성격", key: "kind" },
    { title: "관계 카테고리 코드", key: "refCode" }]);
  const [filters] = useState([
    {
      title: "분류 선택",
      type: "select",
      key: "searchType",
      options: {
        list: CATEGORY_SEARCH_OPTIONS,
      },
    },
    {
      title: "키워드 검색",
      type: "input",
      key: "searchText",
      className: "input-focus",
      placeholder: "검색어 입력",
    },
  ]);

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      searchType: 'name',
      searchText: '',
      page: 0,
      limit: 10
    },
  );

  useEffect(() => {
    _submit(form);
    setSubmit(_submit);
    setTimeout(() => {
      const target = document.getElementsByClassName('input-focus');
      if (target && target[0]) target[0].focus();
    }, 500);
  }, []);

  const _submit = (_params) => {
    setIsLoading(true);
    getAccountingTitleList(getParams(_params))
      .then((res) => {
        setList(res.data.accountingTitles);
        setTotal(res.data.totalCount);
      })
      .catch(() => { })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const cancel = () => {
    setOpen(false);
    mode === "modify" && setSelectedItem([]);
  };

  const handleOnSupply = () => {

    systemAlert('카테고리를 매핑하시겠습니까?', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '승인',
          onClick: () => {
            if (mode === "modify") {
              const promiseList = [];
              viewLoading(true);
              each(selectedList, item => {
                each(selectedItem, bankItem => {
                  promiseList.push(createAccountingTitleUse(item.idx, {
                    useType,
                    useItemIdx: bankItem.idx
                  }));
                });

              });
              Promise.all(promiseList)
                .then(() => {
                  toast.info('카테고리가 매핑 되었습니다.');
                  cancel();
                  submit();
                })
                .finally(() => {
                  viewLoading(false);
                });
            } else if (mode === "create") {
              if (selectIdx !== null) {
                const categoriesInfo = selectedList.map(item => {
                  return { accountingTitle: item };
                });
                const accountingTitleUses = uniqBy([
                  ...(selectedItem[selectIdx]?.accountingTitleUses || []),
                  ...categoriesInfo
                ], 'accountingTitle.idx');

                selectedItem[selectIdx] = {
                  ...selectedItem[selectIdx],
                  accountingTitleUses
                };
                setSelectedItem(selectedItem);
              };
              cancel();
            }
          }
        }
      ]
    });
  };

  return (
    <>
      <Modal isOpen={open} close={cancel}>
        <div className="category-mapping-modal">
          <ModalHeader>카테고리 매핑하기</ModalHeader>

          {!isEmpty(propsFields) && !isEmpty(selectedItem) && (
            <div className="client-mapping-modal mb-32">
              <div className="mapping-field">
                <table className="w-full">
                  <thead>
                    <tr>
                      {propsFields.map((field, idx) => (
                        <th key={idx}>{field.title}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {selectedItem.map((trans, transIdx) => (
                      <tr key={transIdx} style={{ height: "52px" }}>
                        <td >{dateToViewFormat(get(trans, 'tradeTime'))}</td>
                        <td className="color-red-100">{transformComma(get(trans, 'inAmt'))}</td>
                        <td className="color-purple-100">{transformComma(get(trans, 'outAmt'))}</td>
                        <td >{transformComma(get(trans, 'balanceAmt'))}</td>
                        <td >{get(trans, 'traderName')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>
          )}
          <Filters
            isLoading={isLoading}
            filters={filters}
            submit={filterSubmit}
            form={form}
            onChange={handleOnChange}
          />


          <ControlTable
            isControl
            selectedList={selectedList}
            setSelected={setSelectedList}
            fields={fields}
            list={list}
            isLoading={isLoading}
            total={total}
            page={page}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            submit={handleSubmit}
          />
          <div className="submit-button-wrap float-right margin-top-32">
            <Button
              className="button"
              size="lg"
              label="취소"
              color="text"
              action={cancel}
            />
            <Button
              className="button"
              size="lg"
              label="적용하기"
              disabled={isEmpty(selectedList)}
              action={handleOnSupply}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CategoryMappingModal;